module.exports = __webpack_public_path__ + "img/empty-record.e76aec5c.png";